import React, { Component } from 'react'
import { GET_ONE, GET_MANY, GET_LIST } from 'react-admin'

import { SearchSelect } from '../Inputs'
import dataProvider from '../../utils/dataProvider'

import { uniqBy } from 'lodash'


export class ReferenceSelectInput extends Component {

    constructor(props) {
        super(props);

        this.state = {
            options: [],
            isDisabled : true,
            isLoading : true,
            placeholder : 'Cargando',
            searchType : "default",
        }
    }

    componentDidMount() {
        const { isDisabled, input : { value }, placeholder, reference, filters = {} } = this.props
        const params = {
            pagination: {
                page: 1,
                perPage: 100
            },
            sort: {
                field: 'name',
                order: 'ASC'
            },
            filter: filters
        }

        // Get default Select value(s)
        const valueType = typeof value
        if(value && (valueType === "number" || valueType === "string")){
          dataProvider(GET_ONE, reference, {id : value})
              .then(response => {
                  const { data } = response
                  this.setState({
                      options: [{ value: data.id, label: data.name }],
                  })
              })
              .catch((e) => {
                  this.setState({
                      options: [],
                  })
              });
        } else if (value && valueType === "object" && Array.isArray(value)){
          dataProvider(GET_MANY, reference, {ids : value})
            .then(response => {
              const { data } = response
              const options = data
                .filter(d => !d.__inaccessible)
                .map(d => ({ value: d.id, label: d.name }))
              this.setState({
                options: options,
              })
            })
            .catch((e) => {
              this.setState({
                options: [],
              })
            });
        }

        // Get first 100 elements to populate the Select
        dataProvider(GET_LIST, reference, params)
            .then(response => {
                let data = response.data.map(res => ({ value: res.id, label: res.name }))
                data.unshift({value: false, label: "---"})
                let searchType = this.state.searchType
                if(response.total > 100){
                    searchType = "async"
                    data.push({ value: "", label: "más de 100 elementos...", disabled: true })
                }
                const options = uniqBy([...this.state.options, ...data], 'value')
                this.setState({
                    options: options,
                    isDisabled : isDisabled || false,
                    isLoading : false,
                    placeholder : placeholder || 'Seleccione o Escriba una busqueda',
                    searchType : searchType
                })
            })
            .catch((e) => {
                console.error(e);
            });
    }

    render() {
        const { reference, isMulti, clearOnClick, ...rest } = this.props
        const { options, isDisabled, isLoading, placeholder, searchType } = this.state

        return (
            <SearchSelect
                {...rest}
                options={options}
                isDisabled={isDisabled}
                isLoading={isLoading}
                placeholder={placeholder}
                resource={reference}
                searchType={searchType}
                isMulti={isMulti}
                clearOnClick={!!clearOnClick}
            />
        )
    }
}
